import { render, staticRenderFns } from "./Goto.vue?vue&type=template&id=6ee226f6&scoped=true"
import script from "./Goto.vue?vue&type=script&lang=js"
export * from "./Goto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee226f6",
  null
  
)

export default component.exports